import * as z from "zod";
import { translateShopifyCoverageText } from "./translate-shopify-coverage-text";

export const saveShopifyCoverageText = {
  name: "saveShopifyCoverageText" as const,
  input: translateShopifyCoverageText.input.extend({
    drafts: translateShopifyCoverageText.output.shape.drafts,
  }),
  output: z.object({ fields: z.number(), saved: z.number() }),
};
